import { colors, spacing, typography } from '../../styles/theme';

export const cadStockLegendRootStyle = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  gap: `${spacing.unit}px ${spacing.sm}`,
  width: 'max-content',
  maxWidth: '100%',
  boxSizing: 'border-box',
  padding: `6px ${spacing.sm}`,
  backgroundColor: colors.backgroundSurface,
  color: colors.textPanelDescription,
  border: `1px solid ${colors.border}`,
  borderRadius: '999px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.28)',
  fontFamily: typography.fontFamily.primary,
  fontSize: typography.fontSize.xs,
  lineHeight: typography.lineHeight.tight,
  // El wrapper de MapControls usa pointer-events: none; sin esto el click
  // atraviesa al mapa y el filtro de stock no corre.
  pointerEvents: 'auto',
};

export const cadStockLegendItemStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  whiteSpace: 'nowrap',
};

/** Badge clickeable: mismo look que el ítem, sin chrome de botón nativo. */
export const cadStockLegendItemButtonStyle = {
  ...cadStockLegendItemStyle,
  margin: 0,
  padding: '2px 4px',
  border: 'none',
  borderRadius: 6,
  background: 'transparent',
  color: 'inherit',
  font: 'inherit',
  cursor: 'pointer',
  appearance: 'none',
  WebkitAppearance: 'none',
};

export const cadStockLegendDotStyle = {
  width: 8,
  height: 8,
  borderRadius: '50%',
  flexShrink: 0,
};
